/* DVR - atalhos entre as colecoes do vestuario.
   Quem entrava em Mistico via so as 12 pecas de Mistico e nao tinha como ir
   para Magico ou Botanico sem voltar pelo menu. Aqui as colecoes viram uma
   fila de atalhos na primeira linha da barra de escolhas, com a atual marcada.
   Na pagina do Vestuario nao entra: la o filtro proprio ja faz isso. */
(function () {
  'use strict';
  var LISTA = window.DVR_GOSTOS || [];
  var AQUI = window.DVR_AQUI || '';
  if (!LISTA.length || !AQUI || AQUI === 'vestuario') return;
  var pertence = false;
  for (var i = 0; i < LISTA.length; i++) { if (LISTA[i][0] === AQUI) pertence = true; }
  if (!pertence) return;

  var s = document.createElement('style');
  s.textContent =
    '.dvrc-g{flex:1 1 100%;min-width:0}' +
    '.dvrc-ops{flex-wrap:nowrap;overflow-x:auto;scrollbar-width:none;max-width:100%;padding-bottom:3px}' +
    '.dvrc-ops::-webkit-scrollbar{display:none}' +
    '.dvrc-ops button{flex:0 0 auto;white-space:nowrap}';
  document.head.appendChild(s);

  function monta() {
    var barra = document.querySelector('.dvrv-barra');
    if (!barra) return false;
    if (barra.querySelector('.dvrc-g')) return true;

    var g = document.createElement('div');
    g.className = 'dvrv-g dvrc-g';

    var rot = document.createElement('span');
    rot.className = 'dvrv-rot';
    var longa = document.createElement('span');
    longa.className = 'dvrv-longa';
    longa.textContent = 'Ver outra coleção';
    var curta = document.createElement('span');
    curta.className = 'dvrv-curta';
    curta.textContent = 'Coleções';
    rot.appendChild(longa); rot.appendChild(curta);

    var ops = document.createElement('div');
    ops.className = 'dvrv-ops dvrc-ops';
    for (var i = 0; i < LISTA.length; i++) {
      var it = LISTA[i];
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = it[0] === 'vestuario' ? 'Todas as estampas' : it[1] + ' · ' + it[2];
      if (it[0] === AQUI) b.className = 'on';
      b.setAttribute('data-ir', it[3]);
      ops.appendChild(b);
    }
    ops.addEventListener('click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('button') : null;
      if (!b) return;
      var u = b.getAttribute('data-ir');
      if (u) window.location.href = u;
    });

    g.appendChild(rot); g.appendChild(ops);
    barra.insertBefore(g, barra.firstChild);

    /* deixa a coleção atual visível na fila, sem mover a página */
    var on = ops.querySelector('button.on');
    if (on) ops.scrollLeft = Math.max(0, on.offsetLeft - 16);
    return true;
  }

  var n = 0;
  var t = setInterval(function () { if (monta() || ++n > 60) clearInterval(t); }, 150);
  document.addEventListener('DOMContentLoaded', monta);
  window.addEventListener('load', monta);
})();
